const fields = [
  {
    dataIndex: 'name',
    key: 'name',
    title: '服务内容',
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'auditStatusStr',
    key: 'auditStatus',
    scopedSlots: {
      customRender: 'color'
    },
    title: '状态'
  },
  {
    dataIndex: 'createTime',
    key: 'createTime',
    title: '创建时间'
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 12,
    label: '需求名称',
    component: 'AInput',
    placeholder: '请输入需求名称',
    prop: 'name',
    allowClear: true
  },
  {
    span: 8,
    label: '创建日期',
    component: 'ASelect',
    prop: 'searchValue',
    placeholder: '选择创建日期',
    list: [
      { label: '全部日期', value: 0 },
      { label: '近一个月', value: 1 },
      { label: '近三个月', value: 2 },
      { label: '近半年', value: 3 },
      { label: '近一年', value: 4 }
    ]
  }
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [
      { name: '通过', cb: 'pass' },
      { name: '不通过', cb: 'noPass', divider: true }
    ]
  }
]

module.exports = {
  fields,
  slotOpt,
  formRow
}
